import { QuestionModel } from "../../models/QuestionModel";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { ControlProps } from "../controls/BaseControl";
import { ChoiceProps } from "../choices/BaseChoice";
import { ThemeModel } from "../../models/ThemeModel";
import { VariableModel } from "../../models/VariableModel";

export interface RendererProps {
    question: QuestionModel;
    questionnaire: QuestionnaireModel;
    theme: ThemeModel;
    language: string;
    variable?: VariableModel;
    children?: any;
    mobileOnly?: boolean;
    gridRendering?: boolean;
    standardOnly?: boolean;
    showIfMobile?: boolean;
    showIfStandard?: boolean;
    showSoftPrompt?: boolean;
    gridRenderedColumnIndex?: number;
    gridRenderedRowIndex?: number;
    isRowHeader?: boolean;
}

export function getRendererProps(props: RendererProps | ControlProps | ChoiceProps) {
    return {
        question: props.question,
        questionnaire: props.questionnaire,
        theme: props.theme,
        language: props.language,
        gridRendering: props.gridRendering,
        mobileOnly: (props as RendererProps).mobileOnly,
        standardOnly: (props as RendererProps).standardOnly,
        showSoftPrompt: (props as ControlProps).showSoftPrompt,
        gridRenderedColumnIndex: ((props as RendererProps) || (props as ControlProps))
            .gridRenderedColumnIndex,
        gridRenderedRowIndex: ((props as RendererProps) || (props as ControlProps))
            .gridRenderedRowIndex,
        isRowHeader: (props as RendererProps).isRowHeader,
    };
}
